import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { CalendarClock, Loader2, CheckCircle2, XCircle, Play, Flag, Clock, Star, MessageSquare } from "lucide-react";
import { toast } from "sonner";

const FILTERS = [["attive", "Attive"], ["completata", "Completate"], ["annullata", "Annullate"], ["", "Tutte"]];
const ACTIVE = ["richiesta_inviata", "in_attesa", "confermata", "in_corso"];

function Bookings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("attive");

  const load = async () => { setLoading(true); const { data } = await api.get("/provider/service-bookings"); setItems(data); setLoading(false); };
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  const act = async (b, action, extra = {}) => {
    try { await api.patch(`/provider/service-bookings/${b.id}`, { action, ...extra }); toast.success("Aggiornato"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const propose = (b) => { const dt = window.prompt("Nuovo orario proposto (YYYY-MM-DDTHH:MM):", b.booking_datetime || ""); if (!dt) return; act(b, "propose", { datetime: dt }); };
  const reject = (b) => { const note = window.prompt("Motivo del rifiuto (facoltativo):") || ""; act(b, "reject", { note }); };
  const shown = items.filter((b) => filter === "attive" ? ACTIVE.includes(b.status) : (filter ? b.status === filter : true));

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {FILTERS.map(([k, l]) => (
          <button key={k || "all"} data-testid={`bk-filter-${k || "all"}`} onClick={() => setFilter(k)}
            className={`text-sm rounded-full px-4 py-1.5 border ${filter === k ? "bg-[#00E676] text-black border-[#00E676]" : "bg-white/5 text-zinc-300 border-white/15"}`}>{l}</button>
        ))}
      </div>
      {loading ? <div className="text-zinc-500 py-10 text-center"><Loader2 className="h-4 w-4 animate-spin inline" /> Caricamento…</div> : (
        <div className="space-y-3 mt-3">
          {shown.length === 0 && <div className="text-zinc-500 py-14 text-center border border-dashed border-white/10 rounded-xl">Nessuna prenotazione.</div>}
          {shown.map((b) => (
            <div key={b.id} data-testid={`bk-card-${b.id}`} className="bg-[#1C1C1F] border border-white/10 rounded-xl p-4">
              <div className="flex items-start justify-between gap-2 flex-wrap">
                <div className="min-w-0">
                  <div className="font-semibold flex items-center gap-2">{b.title}
                    <span className="text-[10px] rounded-full px-2 py-0.5 border" style={{ background: `${b.step_color}1f`, color: b.step_color, borderColor: `${b.step_color}55` }} data-testid={`bk-status-${b.id}`}>{b.step_label}</span>
                  </div>
                  <div className="text-xs text-zinc-500 mt-0.5">{b.customer_name} · {b.category} · {Number(b.amount) > 0 ? `€${Number(b.amount).toFixed(2)}` : "Preventivo"} · {b.participants || 1} pers.</div>
                  {b.booking_datetime && <div className="text-xs text-zinc-400 mt-0.5 flex items-center gap-1"><Clock className="h-3 w-3" /> {String(b.booking_datetime).replace("T", " · ")}</div>}
                  {b.proposed_datetime && <div className="text-xs text-[#93C5FD] mt-0.5">Orario proposto (in attesa del cliente): {String(b.proposed_datetime).replace("T", " · ")}</div>}
                  {b.notes && <div className="text-xs text-zinc-500 mt-0.5">Note: {b.notes}</div>}
                  {b.reject_note && <div className="text-xs text-red-400 mt-0.5">Rifiuto: {b.reject_note}</div>}
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {["richiesta_inviata", "in_attesa"].includes(b.status) && <>
                    <button data-testid={`bk-confirm-${b.id}`} onClick={() => act(b, "confirm")} className="text-xs flex items-center gap-1 rounded-md bg-[#00E676]/15 text-[#00E676] border border-[#00E676]/30 px-2.5 py-1.5"><CheckCircle2 className="h-3 w-3" /> Conferma</button>
                    {b.flow_mode === "slot_booking" && <button data-testid={`bk-propose-${b.id}`} onClick={() => propose(b)} className="text-xs flex items-center gap-1 rounded-md bg-[#60A5FA]/15 text-[#60A5FA] border border-[#60A5FA]/30 px-2.5 py-1.5"><CalendarClock className="h-3 w-3" /> Proponi orario</button>}
                    <button data-testid={`bk-reject-${b.id}`} onClick={() => reject(b)} className="text-xs flex items-center gap-1 rounded-md bg-red-500/10 text-red-400 border border-red-500/20 px-2.5 py-1.5"><XCircle className="h-3 w-3" /> Rifiuta</button>
                  </>}
                  {b.status === "confermata" && <>
                    <button data-testid={`bk-start-${b.id}`} onClick={() => act(b, "start")} className="text-xs flex items-center gap-1 rounded-md bg-[#22D3EE]/15 text-[#22D3EE] border border-[#22D3EE]/30 px-2.5 py-1.5"><Play className="h-3 w-3" /> Avvia</button>
                    <button data-testid={`bk-complete-${b.id}`} onClick={() => act(b, "complete")} className="text-xs flex items-center gap-1 rounded-md bg-[#00E676]/15 text-[#00E676] border border-[#00E676]/30 px-2.5 py-1.5"><Flag className="h-3 w-3" /> Completa</button>
                  </>}
                  {b.status === "in_corso" && <button data-testid={`bk-complete-${b.id}`} onClick={() => act(b, "complete")} className="text-xs flex items-center gap-1 rounded-md bg-[#00E676]/15 text-[#00E676] border border-[#00E676]/30 px-2.5 py-1.5"><Flag className="h-3 w-3" /> Completa</button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

function Reviews() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => { setLoading(true); const { data } = await api.get("/provider/service-reviews"); setItems(data); setLoading(false); };
  useEffect(() => { load(); }, []);
  const reply = async (r) => {
    const text = window.prompt("La tua risposta:", r.provider_reply || ""); if (!text) return;
    try { await api.post(`/provider/service-reviews/${r.id}/reply`, { reply: text }); toast.success("Risposta pubblicata"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (loading) return <div className="text-zinc-500 py-10 text-center"><Loader2 className="h-4 w-4 animate-spin inline" /> Caricamento…</div>;
  return (
    <div className="space-y-3 mt-3">
      {items.length === 0 && <div className="text-zinc-500 py-14 text-center border border-dashed border-white/10 rounded-xl">Nessuna recensione ancora.</div>}
      {items.map((r) => (
        <div key={r.id} data-testid={`prov-review-${r.id}`} className="bg-[#1C1C1F] border border-white/10 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1 text-[#FFD700]">{"★".repeat(r.rating)}<span className="text-zinc-400 text-sm ml-1">{r.customer_name}</span></div>
            {r.status !== "published" && <span className="text-[10px] rounded-full px-2 py-0.5 bg-red-500/15 text-red-400 border border-red-500/30">{r.status === "hidden" ? "Nascosta" : "Rimossa"}</span>}
          </div>
          {r.comment && <p className="text-sm text-zinc-300 mt-1">{r.comment}</p>}
          {r.provider_reply ? (
            <p className="text-xs text-zinc-400 mt-2 pl-2 border-l-2 border-[#7DF9FF]/40"><b>Tua risposta:</b> {r.provider_reply}</p>
          ) : (
            <button data-testid={`prov-reply-${r.id}`} onClick={() => reply(r)} className="text-xs mt-2 flex items-center gap-1 rounded-md bg-white/5 border border-white/10 px-2.5 py-1.5"><MessageSquare className="h-3 w-3" /> Rispondi</button>
          )}
        </div>
      ))}
    </div>
  );
}

export default function ServiceBookingsPanel() {
  const [tab, setTab] = useState("bookings");
  return (
    <div className="space-y-5" data-testid="service-bookings-panel">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-[#7DF9FF]/15 border border-[#7DF9FF]/30 flex items-center justify-center"><CalendarClock className="h-5 w-5 text-[#7DF9FF]" /></div>
        <div><h2 className="font-display text-xl font-bold">Prenotazioni e recensioni</h2><p className="text-sm text-zinc-400">Gestisci le richieste delle Esperienze AI e rispondi alle recensioni.</p></div>
      </div>
      <div className="flex gap-2 bg-[#141417] border border-white/10 rounded-full p-1 w-fit">
        <button data-testid="bk-tab-bookings" onClick={() => setTab("bookings")} className={`text-sm rounded-full px-5 py-1.5 font-semibold ${tab === "bookings" ? "bg-[#00E676] text-black" : "text-zinc-400"}`}>Prenotazioni</button>
        <button data-testid="bk-tab-reviews" onClick={() => setTab("reviews")} className={`text-sm rounded-full px-5 py-1.5 font-semibold flex items-center gap-1 ${tab === "reviews" ? "bg-[#00E676] text-black" : "text-zinc-400"}`}><Star className="h-3.5 w-3.5" /> Recensioni</button>
      </div>
      {tab === "bookings" ? <Bookings /> : <Reviews />}
    </div>
  );
}
